import { useEffect, useState, lazy, Suspense } from 'react';
import useAuth from '../../../hooks/useAuth';
import { toast } from 'react-toastify';
import { useUploadImageToS3BucketMutation } from '../../ImagesGallery/imagesGalleryApiSlice';
import StyledLoading from '../../../app/components/loading/StyledLoading';
import StyledText from '../../../app/components/styledComponents/StyledText';
import { useDispatch } from 'react-redux';
import { setGalleryImages } from '../../../app/services/imagesGallery';
import { formatTimestamp, removeFileNameDots } from '../../../utils/helper';
import './GalleryImageEditor.css';

const FileRobotImageEditor = lazy(() => import('react-filerobot-image-editor'));
const TABS = lazy(() => import('../../../defaultNamedExports'));

// const TABS = {
//   RESIZE: 'resize',
//   FINETUNE: 'finetune',
//   FILTERS: 'filters',
//   WATERMARK: 'watermark',
//   ANNOTATE: 'annotate',
//   ADJUST: 'adjust',
// };

function GalleryImageEditor({ editImage, updateData, onClose }) {
  const { user } = useAuth();
  const dispatch = useDispatch();
  // const [uploadImageAPI, { isLoading: loading }] = useUploadImageMutation();
  // const [uploadFloristImage] = useUploadFloristImagesMutation();
  const [uploadToBucket] = useUploadImageToS3BucketMutation();
  const [anotationObject, setAnotationObject] = useState(null);

  useEffect(() => {
    const handleClick = (e) => {
      const textEditElement2 = document.querySelector(
        '.FIE_editor-content.text-edit-stl',
      );
      if (textEditElement2) {
        textEditElement2.classList.remove('text-edit-stl');
        setAnotationObject(null);
      }
    };

    const handleKeyDown = (event) => {
      const textEditElement = document.querySelector('.FIE_editor-content');
      if (
        textEditElement &&
        textEditElement?.classList?.contains('text-edit-stl')
      )
        return;

      textEditElement.classList.add('text-edit-stl');
      const textEditElement2 = document.querySelector(
        '.FIE_editor-content.text-edit-stl',
      );
      if (textEditElement2)
        textEditElement2.addEventListener('click', handleClick);
    };

    const observeElement = document.querySelector(
      '.FIE_editor-content .FIE_canvas-container',
    );

    const observerCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeName === 'TEXTAREA') {
              node.addEventListener('keydown', handleKeyDown);
            }
          });
          // Check added and removed nodes
          mutation.removedNodes.forEach((removedNode) => {
            if (removedNode.nodeName === 'TEXTAREA') {
              handleClick();
            }
          });
        }
      }
    };

    const observer = new MutationObserver(observerCallback);

    if (observeElement) {
      observer.observe(observeElement, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      if (observeElement) {
        observer.disconnect();
      }
    };
  }, [editImage, anotationObject]);

  const uploadedOn = formatTimestamp(Date.now().toString());
  const singleImageObj = {
    progress: 0,
    uploading: true,
    uploadedOn: uploadedOn,
    uploadedBy: `${user.firstName} ${user.lastName}`,
    uploadedTo: '',
    fileSize: '',
    dimension: '',
    alternativeText: editImage?.alternativeText || '',
    title: editImage?.title || '',
    caption: editImage?.caption || '',
    description: editImage?.description || '',
    copyLink: editImage?.copyLink || '',
    tagDTOS: editImage?.tagDTOS || [],
    imageCategory : editImage?.imageCategory || {},
    imageDTO: {
      content: '',
      fileName: '',
      extension: '',
    },
  };

  const saveImages = async (editedImageObject) => {
    try {
      const imgObj = singleImageObj;
      imgObj.dimension = `${editedImageObject?.width} by ${editedImageObject?.height} Pixels`;

      const blob = await fetch(editedImageObject?.imageBase64);
      if (!blob.ok) {
        throw new Error('Failed to fetch image data');
      }
      const blobData = await blob.blob();

      const file = new File([blobData], editedImageObject?.name, {
        type: editedImageObject?.mimeType,
      });

      const temporaryImageUrl = URL.createObjectURL(file);

      imgObj.imageDTO = {
        fileName: removeFileNameDots(
          file?.name,
        ),
        extension: file.type,
        url: temporaryImageUrl,
      };
      imgObj.originalFile = file;
      imgObj.uploadedOn = uploadedOn;

      const payload = {
        floristId: user?.floristId,
        isFlorist: true,
        shopName: user?.floristDTO?.companyName,
        uuid: user?.floristDTO?.uuid,
        floristImagesDTOS: [imgObj],
      };

      dispatch(setGalleryImages({ images: [imgObj], isFlorist: true }));
      onClose();
      await uploadToBucket(payload);
      updateData();
    } catch (error) {
      toast.error('Failed');
    }
  };

  return (
    <>
      {editImage && (
        <>
          <StyledText
            $fontSize={'18px'}
            $fontWeight={'500'}
            color={'bodyMedium'}
          >
            Save will create new copy to your Image Gallery
          </StyledText>
          <Suspense fallback={<StyledLoading />}>
            <FileRobotImageEditor
              useBackendTranslations={false}
              defaultSavedImageType={
                editImage?.imageDTO?.extension?.includes('png') ? 'png' : 'jpg'
              }
              forceToPngInEllipticalCrop
              onModify={(e) => {
                if (anotationObject == null) setAnotationObject(e.annotations);
              }}
              source={editImage?.imageDTO?.url || editImage?.imageDTO?.content}
              disableSaveIfNoChanges={true}
              onSave={(editedImageObject) => {
                //
                saveImages(editedImageObject);
              }}
              onBeforeSave={() => false}
              onClose={onClose}
              tabsIds={[
                TABS.RESIZE,
                TABS.FINETUNE,
                TABS.FILTERS,
                TABS.WATERMARK,
                TABS.ANNOTATE,
                TABS.ADJUST,
              ]}
              defaultTabId={TABS.FILTERS} // or 'Annotate'
              Rotate={{
                angle: 90,
                componentType: 'buttons',
              }}
            />
          </Suspense>
        </>
      )}
      {/* {loading && (
        <div>
          <StyledLoading />
        </div>
      )} */}
    </>
  );
}

export default GalleryImageEditor;
